import {Component, inject} from '@angular/core';
import {LoginFormComponent} from './forms/login-form/login-form.component';
import {SignupFormComponent} from './forms/signup-form/signup-form.component';
import {ForgotPasswordFormComponent} from './forms/forgot-password-form/forgot-password-form.component';
import {ResetPasswordFormComponent} from './forms/reset-password-form/reset-password-form.component';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../../core/auth/auth.service';

@Component({
  selector: 'app-auth-page',
  imports: [
    LoginFormComponent,
    SignupFormComponent,
    ForgotPasswordFormComponent,
    ResetPasswordFormComponent
  ],
  templateUrl: './auth-page.component.html',
  styleUrl: './auth-page.component.css',
})

export class AuthPageComponent {

  isSignup: boolean = false;
  isLogin: boolean = true;
  isForgotPassword: boolean = false;
  isResetPassword: boolean = false;
  isLogged: boolean = false;
  authService: AuthService = inject(AuthService);

  constructor(private router: Router, activatedRoute: ActivatedRoute) {

    const path = activatedRoute.snapshot.routeConfig?.path;

    if (path === 'logout') {
      this.logout();
    } else {
      this.isLogin = path === 'login';
      this.isSignup = path === 'signup';
      this.isForgotPassword = path === 'forgot-password';
      this.isResetPassword = path === 'reset-password';
      this.getIsLogged();
    }
  }

  logout() {
    this.isLogged = true;
    this.isLogin = true;
    this.authService.logout();
  }

  getIsLogged() {
    this.isLogged = !this.authService.isLogged();
  }

}






